export enum PromotionPublishedTypeEnum {
  NOW = 'NOW',
  PERIOD = 'PERIOD',
}
